module.exports = __webpack_public_path__ + "img/Eisopa.dcd436cf.jpg";